export enum ProviderSelectionAction {
  HAS_PROVIDER = "HAS_PROVIDER",
  NO_PROVIDER = "NO_PROVIDER",
  SKIPPED = "SKIPPED"
}

export type MemberProviderSelection = {
  memberProviderSelectionId?: number
  employeeId?: number
  providerUuid?: number
  providerEntityName?: string
  providerFirstName?: string
  providerLastName?: string
  routingInfoId?: number
  selectionSource: "HOMEPAGE" | "ROUTING"
  createdAt?: string
  providerEligibilityStatusAtSelection?: string
  providerType?: string | null
  providerSelectionAction?: ProviderSelectionAction | null
  sawProviderTypeStep?: boolean
}

export type UpsertMemberProviderSelectionRequest = {
  selectionSource: "HOMEPAGE" | "ROUTING"
  providerUuid?: number
  providerEntityName?: string
  providerFirstName?: string
  providerLastName?: string
  routingInfoId?: number
  providerEligibilityStatusAtSelection?: string
  providerType?: string | null
  providerSelectionAction?: ProviderSelectionAction | null
  sawProviderTypeStep?: boolean
}
